window.addEventListener('load', function () {
    document.addEventListener('click', function (e) {
        const target = e.target.closest('.js-toggle-password')
        if (!target) return

        togglePassword(target)
    })

    const togglePassword = (toggleButton) => {
        const inputParent = toggleButton.closest('.js-input')
        const inputEl = inputParent.querySelector('.js-input-field')
        const hiddenIcon = toggleButton.querySelector('.js-toggle-password-icon.hidden')
        const activeIcon = toggleButton.querySelector('.js-toggle-password-icon:not(.hidden)')

        if (inputEl.getAttribute('type') === 'password') {
            inputEl.setAttribute('type', 'text')
        } else {
            inputEl.setAttribute('type', 'password')
        }

        activeIcon.classList.add('hidden')
        hiddenIcon.classList.remove('hidden')
    }
})
